import actions from "./actions";
import mutations from "./mutations";

export default {
    namespaced: true,
    state() {
        return {
            users: {
                data: [],
                meta: {},
            },
            fetched: false,
        }
    },
    actions,
    mutations,
}
